import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { setDateRange, setFilteredSegment } from '../ui/reducer';
import { SidebarData, SidebarState } from './types';

export type SidebarSliceState = {
    sidebar?: SidebarState;
};

export const defaultState: SidebarSliceState = {
    sidebar: undefined,
};

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: defaultState,
    reducers: {
        showSidebar(state, { payload }: PayloadAction<{ data: SidebarData; type: string }>) {
            const { data, type } = payload;
            if (data) {
                state.sidebar = { data, type };
            }
        },
        hideSidebar(state) {
            state.sidebar = undefined;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setFilteredSegment, (state) => {
            state.sidebar = undefined;
        });
        builder.addCase(setDateRange, (state) => {
            state.sidebar = undefined;
        });
    },
});

export const { showSidebar, hideSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
